import { RadioGroup, RadioGroupItem } from "~/components/ui/radio-group";
import { Label } from "~/components/ui/label";

interface Props {
  value: number | null | undefined;
  onChange: (a: string | number | null) => void;
  disabled?: boolean;
}

const PDFOptionSelect = (props: Props) => {
  const { value, onChange } = props;
  const disabled = props.disabled ?? false;
  const pdfOptions = [
    { value: "PDF Not Allowed", label: "Do not convert to PDF" },
    { value: "PDF Allowed", label: "Convert to PDF" },
    // { value: "PDF Preferred download type", label: "PDF Preferred download type" },
    // { value: "Only allow pdf format", label: "Only allow pdf format" },
  ];

  return (
    <RadioGroup
      value={String(value)}
      onValueChange={(v) => onChange(String(v) || null)}
      disabled={disabled}
      className="gap-2"
    >
      {pdfOptions.map((opt) => {
        const vs = String(opt.value);
        return (
          <div key={vs} className="flex items-center gap-2">
            <RadioGroupItem id={`pdf-${vs}`} value={vs} />
            <Label htmlFor={`pdf-${vs}`} className="cursor-pointer font-normal">
              {opt.label}
            </Label>
          </div>
        );
      })}
    </RadioGroup>
  );
};

export default PDFOptionSelect;
